export const YEARLY_DISCOUNT = 'YearlyDiscount';
